(function () {

    /**
     * Send tracking event to server
     */
    window.trackEvent = function (statModel, statEvent, payload = {}) {

        const data = {
            stat_model: statModel,
            stat_event: statEvent,
            url: window.location.href,
            ...payload
        };

        const json = JSON.stringify(data);

        // Prefer sendBeacon
        if (navigator.sendBeacon) {
            const blob = new Blob([json], {
                type: 'application/json'
            });
            navigator.sendBeacon('/api/stats/track-event', blob);
            return;
        }

        // Fallback
        fetch('/api/stats/track-event', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: json,
            keepalive: true
        });
    };

    /**
     * Send batch impression tracking to server
     */
    window.trackBatchImpressions = function (statModel, statIds) {
        if (!statIds || !statIds.length) return;

        const data = {
            stat_model: statModel,
            stat_ids: statIds,
            url: window.location.href,
        };

        const json = JSON.stringify(data);

        if (navigator.sendBeacon) {
            const blob = new Blob([json], { type: 'application/json' });
            navigator.sendBeacon('/api/stats/track-impressions', blob);
            return;
        }

        fetch('/api/stats/track-impressions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: json,
            keepalive: true,
        });
    };

    /**
     * Auto-track elements using data-attributes
     */
    document.addEventListener('click', function (e) {

        const el = e.target.closest('[data-stat-event]');
        if (!el) return;

        const statModel = el.dataset.statModel;
        if (!statModel) return;

        const statEvent = el.dataset.statEvent;
        if (!statEvent) return;

        const payload = {};

        if (el.dataset.statId) payload.stat_id = el.dataset.statId;

        window.trackEvent(statModel, statEvent, payload);
    });
})();
